/** `yarn start:fake`: the guest pages run on fixture data and nothing reaches the backend or Bunny. */
export const FAKE_API = process.env.REACT_APP_FAKE_API === 'true';

/** Network-like latency, so loading states stay visible in fake mode. */
export function fakeDelay(ms: number = 700) {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
}
